<template>
  <div>

    <div id="capture"  class="typedSignature" :style="getFontStyle"  @click="convertHtmlToCanvas()" >
      <p style="padding: 2px;" ref="canvas">{{typedSignature}}</p>
    </div>



  </div>
</template>

<script>
  import html2canvas from 'html2canvas';
  import Signature from "@/classes/Signature";


  export default {
    name:'type-signature',

    props:{
      typedSignature : {
        default: ''
      },

        fontFamilyId:{
          default: 0
        },
    },

    data(){
      return {
          returnUrl : false,
          imageURL :'',

          fontFamilies:[
            "Sacramento-Regular",
            "MonsieurLaDoulaise-Regular",
            "Brotherhood_Script",
            "Adine Kirnberg",
            "AlexBrush-Regular",
            "AdineKirnberg-Alternate"

          ],

      }
    },

    computed:{
      getFontStyle(){

        return {
          "font-family" : this.fontFamilies[this.fontFamilyId]
        }
      }
    },

    methods:{

      convertHtmlToCanvas(){
        console.log("convertHtmlToCanvas() method called")
        var capturedSignImage = null

        html2canvas(this.$refs.canvas,{scale:3}).then(canvas=>{
          capturedSignImage = canvas


          // Download as image to test --------------------------
            let href = capturedSignImage.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");
            console.log("Canvas Ref Details : "+this.$refs.canvas)

            // let a = document.createElement('a');
            // a.href = href
            // a.download = 'signature_image.jpg';
            // a.click();
            //
            //
            // setTimeout(() => {
            //   a.remove()
            //   window.URL.revokeObjectURL(href);
            // }, 100);

            // End downloading as image ---------------------------

            capturedSignImage.toBlob((blob) => {
              let file = new File([blob], 'digitally_generated_signature.jpg', { type: "image/jpeg" })

              let returnSignature = new Signature('text', href, file, false, null)
              this.$emit('on-html-to-canvas', returnSignature)

            }, 'image/jpeg');

        });

        capturedSignImage = null
      },

    },

  }

</script>

<style scoped>
  .typedSignature:hover{
    background-color: #D0F8C4;
    cursor: pointer;
  }

  .typedSignature{
    padding: 5px;
    min-width: 150px;
    min-height: 100px;

    border: 1px solid #93FF73;
    border-radius: 12px;
    background-color: #FFFFFF;

    display: flex;
    justify-content: center;
    align-items: center;


    font-size: 22px;
  }




</style>